import styled from "styled-components";
import { Box } from "@mui/material";
import { grey } from "@mui/material/colors";
export const ImageUploaderWrapper = styled(Box)`
	width: 100%;
	box-sizing: border-box;

	.border-dashed {
		border: 1px dashed;
		padding: 20px 10px;
		cursor: pointer;
		background: #fff;
		display: flex;
		flex-direction: column;
		align-items: center;
		grid-gap: 20px;
		.icon {
			width: 50px;
			height: 50px;
			color: #888888;
		}
	}
	.max_count {
		font-size: 12px;
		color: ${grey[700]};
	}
	.gallery-list {
		overflow: auto;

		.MuiBadge-root {
			width: 100%;
			.MuiBadge-badge {
				top: 14px;
				right: 8px;
			}
		}
		.image_delete {
			position: absolute;
			right: 5px;
			bottom: 5px;
			button {
				background: ${grey[300]};
				svg {
					width: 18px;
					height: 18px;
				}
			}
		}
	}
`;
